import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { GENERAL_RULES_CONSTANTS } from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import { DynamicSelectConfig } from "@/shared/components/DynamicSelect/model/DynamicSelectConfig";
import { DynamicSelectData } from "@/shared/components/DynamicSelect/model/DynamicSelectData";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ObjFilterList } from "../../model/List";
import { STYLE_CLASSES } from "./../../../../constants/StyleConstants";
import { DATE_OPERATORS_OBJ } from "@/shared/constants/GeneralConstants";
import {
  EVENT_EMITTER,
  GENERIC_SEARCH_LABELS
} from "../../constants/GenericSearchConstants";

@Component({
  name: "FilterTypeDate",
  components: { DynamicSelect }
})
export default class FilterTypeDate extends Vue {
  @Prop({ default: () => false }) isPrincipal!: boolean;
  @Prop() itemFilter!: SecondaryFilter;
  @Prop() private selectFilter!: ObjFilterList[];
  @Prop({ default: () => "" }) attachRef!: string;

  GENERAL_RULES_CONSTANTS = GENERAL_RULES_CONSTANTS;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  menu = false;
  value: any = "";
  date: string[] | string = "";
  clearData = 0;

  dynamicSelectConfig: DynamicSelectConfig = {
    multiple: false,
    default: [],
    listAll: (this.itemFilter.operators! as unknown) as DynamicSelectData[],
    filled: false,
    hideDetails: true,
    messageLabel: GENERIC_SEARCH_LABELS.OPERACION,
    attach: false,
    required: false
  };
  dynamicSelectList: DynamicSelectData[] = [];
  listKey = 0;

  beforeMount() {
    this.initFilter();
  }

  reload() {
    this.clearData = 1 - this.clearData;
  }

  get selectFilterLocal() {
    return this.selectFilter;
  }

  set selectFilterLocal(filterSelected: ObjFilterList[]) {
    this.$emit(EVENT_EMITTER.UPDATE_SELECT_FILTER, filterSelected);
  }

  get isRange(): boolean {
    const isRange =
      this.dynamicSelectList[0]?.name === DATE_OPERATORS_OBJ.BETWEEN.name;
    this.date = isRange ? [] : "";
    return isRange;
  }

  saveDate(date: string | string[]) {
    if (this.isRange) {
      if (!date[0]) {
        const tempDat1 = new Date(Date());
        const year = tempDat1.getFullYear();
        const mount = tempDat1.getMonth() + 1;
        const day = tempDat1.getDate();
        const tempDate = `${year}-${mount <= 9 ? "0" : ""}${mount}-${
          day <= 9 ? "0" : ""
        }${day}`;
        date = [tempDate, date[1]];
      }
      const date1 = new Date(date[0]).getTime();
      const date2 = new Date(date[1]).getTime();

      if (date1 > date2) {
        date = [date[1], date[0]];
      }
    }
    this.menu = false;
    this.value = date;
    this.date = date;

    const tenmpR: ObjFilterList[] = [];

    switch (this.dynamicSelectList[0]?.name) {
      case DATE_OPERATORS_OBJ.BETWEEN.name:
        tenmpR.push(
          this.getObjSelect(DATE_OPERATORS_OBJ.GREATER_THAN_OR_EQUALS, date[0])
        );
        tenmpR.push(
          this.getObjSelect(DATE_OPERATORS_OBJ.LESS_THAN_OR_EQUALS, date[1])
        );

        break;
      case DATE_OPERATORS_OBJ.LESS_THAN_OR_EQUALS.name:
        tenmpR.push(
          this.getObjSelect(
            DATE_OPERATORS_OBJ.LESS_THAN_OR_EQUALS,
            date as string
          )
        );
        break;
      case DATE_OPERATORS_OBJ.GREATER_THAN_OR_EQUALS.name:
        tenmpR.push(
          this.getObjSelect(
            DATE_OPERATORS_OBJ.GREATER_THAN_OR_EQUALS,
            date as string
          )
        );
        break;
      case DATE_OPERATORS_OBJ.EQUAL.name:
        tenmpR.push(
          this.getObjSelect(DATE_OPERATORS_OBJ.EQUAL, date as string)
        );
        break;
    }

    this.selectFilterLocal = tenmpR;
  }

  getObjSelect(operationObj: { name: string; key: string }, date: string) {
    const obj: ObjFilterList = {
      key: date,
      name: operationObj.name + " " + date,
      operation: operationObj.key
    };
    return obj;
  }

  @Watch("selectFilter")
  initFilter() {
    if (!this.selectFilter || this.selectFilter.length == 0) {
      this.dynamicSelectList = [];
      this.value = "";
      this.date = "";
    } else if (this.selectFilter.length == 2) {
      const selectOperator = (this.itemFilter.operators?.find(
        operator => operator.key == DATE_OPERATORS_OBJ.BETWEEN.key
      ) as unknown) as DynamicSelectData;

      const date = [this.selectFilter[0].key, this.selectFilter[1].key];
      this.value = date;
      this.date = date;
      this.dynamicSelectList = [selectOperator];
    } else if (this.selectFilter.length == 1) {
      const selectOperator = (this.itemFilter.operators?.find(
        operator => operator.key == this.selectFilter[0].operation
      ) as unknown) as DynamicSelectData;

      this.value = this.selectFilter[0].key;
      this.date = this.selectFilter[0].key;
      this.dynamicSelectList = [selectOperator];
    }

    this.reload();
  }

  detectScroll() {
    this.listKey = 1 - this.listKey;
    this.menu = false;
  }
}
